function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Button/Opslaan",
  transform: "translate(-82.000000, -12.000000)",
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("g", {
  id: "Opslaan"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(82.000000, 12.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.7787034,14.8155269 L12.9692322,14.8155269 L12.9692322,8.00371648 C12.9692322,7.67667359 12.699108,7.41146366 12.3657931,7.41146366 L3.61923678,7.41146366 C3.28617931,7.41146366 3.01609195,7.67670971 3.01609195,8.00371648 L3.01609195,14.8155269 L1.20628966,14.8155269 L1.20628966,1.19190609 L3.01605517,1.19190609 L3.01605517,5.33836208 C3.01605517,5.66540497 3.28617931,5.9306149 3.6192,5.9306149 L12.3657563,5.9306149 C12.699108,5.9306149 12.9691954,5.66536885 12.9691954,5.33836208 L12.9691954,2.24216343 L14.7787034,3.91938239 L14.7787034,14.8155269 L14.7787034,14.8155269 Z M4.22238161,14.8155269 L4.22238161,8.5959693 L11.7626115,8.5959693 L11.7626115,14.8155269 L4.22238161,14.8155269 L4.22238161,14.8155269 Z M4.22238161,4.74607314 L11.7626115,4.74607314 L11.7626115,1.19190609 L4.22238161,1.19190609 L4.22238161,4.74607314 Z M15.7712184,3.21054266 L12.4898943,0.169061851 C12.3775264,0.0652243792 12.2298483,0.00736433409 12.0758069,0.00736433409 L0.603144828,0.00736433409 C0.270087356,0.00736433409 0,0.272610384 0,0.599617156 L0,15.4077436 C0,15.7347865 0.270124138,15.9999964 0.603144828,15.9999964 L3.61923678,15.9999964 L12.3657931,15.9999964 L15.3818851,15.9999964 C15.7152368,15.9999964 15.9853241,15.7347503 15.9853241,15.4077436 L15.9853241,3.66399639 L15.9853241,3.66287675 C15.9853241,3.48142302 15.9022713,3.31889481 15.7712184,3.21054266 L15.7712184,3.21054266 Z",
  id: "Fill-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.66666667,4 L10.3333333,4 C10.5175285,4 10.6666667,3.82072195 10.6666667,3.6 L10.6666667,2.4 C10.6666667,2.17896585 10.5175285,2 10.3333333,2 L9.66666667,2 C9.48273171,2 9.33333333,2.17896585 9.33333333,2.4 L9.33333333,3.6 C9.33333333,3.82072195 9.48273171,4 9.66666667,4",
  id: "Fill-4"
})))));
function SvgSaveIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIconWhite);
export default __webpack_public_path__ + "static/media/save-icon-white.58ddf17349073a80bd258a73e9b9ffd8.svg";
export { ForwardRef as ReactComponent };